import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useAudioPlayerStore } from '@/state/audio-player-store';
import { PlayerUI } from './PlayerUI';

export type PLAY_MODE = 'ONCE' | 'REPEAT' | 'CYCLE';
type ORDER_ENUM = 'PRE' | 'NEXT';

export const AudioPlayer: React.FC = () => {
  const {
    setIsPlaying,
    isPlaying,
    playAudioInfo,
    isLoading,
    setIsLoading,
    setWave,
    setCurrentTime,
    onPre,
    onNext,
    onAudioFinish,
  } = useAudioPlayerStore();

  return (
    <PlayerUI
      playUrl={playAudioInfo?.url || ''}
      isPlaying={isPlaying}
      setIsPlaying={setIsPlaying}
      className="fixed bottom-0"
      onPre={onPre}
      onNext={onNext}
      onFinish={onAudioFinish}
      playAudioInfo={playAudioInfo}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      setWave={setWave}
      setCurrentTime={setCurrentTime}
    />
  );
};
